import moment from 'moment';
import { GRIDS_DATE_DISPLAY_FORMAT } from '../../../../HelperMethods/constants';

const initialState = {
  isloading: false,
  taskTypeSelected: null,
  formDetailButtonVisibleState: false,
  columndefsforGlobalandtaskTypeAttibute: [],
  rowDataForGlobalandtaskTypeAttibute: [],
  rowDataForFormAttribute: [],
  columnDefsForFormAttribute: [],
  formSchema: {},
  formFields: [],
  flagSetting: {
    customAttribute: false,
    globalAttribute: false,
    formData: false,
  },
  flagVisibilitySetting: {
    customAttribute: false,
    globalAttribute: false,
    formData: false,
  },
  showTable: false,
  dateRange: {
    startDate: moment().format(GRIDS_DATE_DISPLAY_FORMAT),
    endDate: moment().format(GRIDS_DATE_DISPLAY_FORMAT),
  },
};

export default initialState;
